import {Button} from 'react-aria-components'
import styled from 'styled-components'

export const CloseButton = styled(Button)`
    background: transparent;
    border: none;
    padding: 0;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
        opacity: 0.7;
        cursor: pointer;
    }

    &:focus {
        outline: 2px solid blue;
    }
`

export const Image = styled.img`
    width: 24px;
    height: 24px;
`
